// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/service/schedule_service.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_common } from "../model/core/common_pb";
import { file_proto_model_core_model_path } from "../model/core/model_path_pb";
import { file_proto_model_core_paging } from "../model/core/paging_pb";
import { file_proto_model_trip_schedule } from "../model/trip/schedule_pb";

/**
 * Describes the file proto/service/schedule_service.proto.
 */
export const file_proto_service_schedule_service = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_field_mask, file_google_protobuf_timestamp, file_proto_model_core_common, file_proto_model_core_model_path, file_proto_model_core_paging, file_proto_model_trip_schedule]);

/**
 * Describes the message carmen.CreateScheduleRequest.
 * Use `create(CreateScheduleRequestSchema)` to create a new message.
 */
export const CreateScheduleRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_schedule_service, 0);

/**
 * Describes the message carmen.CreateScheduleResponse.
 * Use `create(CreateScheduleResponseSchema)` to create a new message.
 */
export const CreateScheduleResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_schedule_service, 1);

/**
 * Describes the message carmen.GetScheduleRequest.
 * Use `create(GetScheduleRequestSchema)` to create a new message.
 */
export const GetScheduleRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_schedule_service, 2);

/**
 * Describes the message carmen.GetScheduleResponse.
 * Use `create(GetScheduleResponseSchema)` to create a new message.
 */
export const GetScheduleResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_schedule_service, 3);

/**
 * Describes the message carmen.ListSchedulesRequest.
 * Use `create(ListSchedulesRequestSchema)` to create a new message.
 */
export const ListSchedulesRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_schedule_service, 4);

/**
 * Describes the message carmen.ListSchedulesResponse.
 * Use `create(ListSchedulesResponseSchema)` to create a new message.
 */
export const ListSchedulesResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_schedule_service, 5);

/**
 * Describes the message carmen.DeleteScheduleRequest.
 * Use `create(DeleteScheduleRequestSchema)` to create a new message.
 */
export const DeleteScheduleRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_schedule_service, 6);

/**
 * Describes the message carmen.DeleteScheduleResponse.
 * Use `create(DeleteScheduleResponseSchema)` to create a new message.
 */
export const DeleteScheduleResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_schedule_service, 7);

/**
 * Describes the message carmen.UpdateScheduleRequest.
 * Use `create(UpdateScheduleRequestSchema)` to create a new message.
 */
export const UpdateScheduleRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_schedule_service, 8);

/**
 * Describes the message carmen.UpdateScheduleResponse.
 * Use `create(UpdateScheduleResponseSchema)` to create a new message.
 */
export const UpdateScheduleResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_schedule_service, 9);

/**
 * Describes the message carmen.UpdateScheduleContentRequest.
 * Use `create(UpdateScheduleContentRequestSchema)` to create a new message.
 */
export const UpdateScheduleContentRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_schedule_service, 10);

/**
 * Describes the message carmen.UpdateScheduleContentResponse.
 * Use `create(UpdateScheduleContentResponseSchema)` to create a new message.
 */
export const UpdateScheduleContentResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_schedule_service, 11);

/**
 * Describes the message carmen.AutoScheduleCandidatesRequest.
 * Use `create(AutoScheduleCandidatesRequestSchema)` to create a new message.
 */
export const AutoScheduleCandidatesRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_schedule_service, 12);

/**
 * Describes the message carmen.AutoScheduleCandidatesResponse.
 * Use `create(AutoScheduleCandidatesResponseSchema)` to create a new message.
 */
export const AutoScheduleCandidatesResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_schedule_service, 13);

/**
 * Describes the message carmen.SchedulingJobInfo.
 * Use `create(SchedulingJobInfoSchema)` to create a new message.
 */
export const SchedulingJobInfoSchema = /*@__PURE__*/
  messageDesc(file_proto_service_schedule_service, 14);

/**
 * @generated from service carmen.ScheduleService
 */
export const ScheduleService = /*@__PURE__*/
  serviceDesc(file_proto_service_schedule_service, 0);

